export default __webpack_public_path__ + "static/media/logo-lab.e2e2f346.svg";